import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchEmployees = createAsyncThunk(
    "employees/fetchEmployees",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/auth/employees");
            const result = response.data;
            return result?.data?.employees || result?.employees || (Array.isArray(result) ? result : []);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
